import styled from 'styled-components';

// Quiet pill button matching the PaddingEditControl Toggle aesthetic — sits
// inside a tinted Field card without the heavy "real button" treatment that
// makes Button (SECONDARY) look like the focal action of the panel.
export const PillButton = styled.button`
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[700]};
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 9999px;
	padding: 4px 12px;
	&:hover {
		background: ${({ theme }) => theme.gray[200]};
	}
	&:active {
		background: ${({ theme }) => theme.gray[0]};
	}
`;
